export const uniqid = () => `_${Math.random().toString(36).substr(2, 9)}`;
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));



// WEBPACK FOOTER //
// ./src/utils/index.js